import { LocalStorageService } from './../../../../core/services/local-storage.service';
import { EsnJobOfferService } from './../../../../core/services/esn-job-offer-service/esn-job-offer.service';
import { Component, inject, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { serverError } from './../../../../core/models/messages';
import { SalarieService } from './../../../../core/services/salarie-service/salarie.service';
import { ToastrService } from 'ngx-toastr';
import { Country, State } from 'country-state-city';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { translations } from '../../../../core/models/call-offer';
import { MatChipEditedEvent, MatChipInputEvent } from '@angular/material/chips';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { SubscriptionService } from '@core/services/subscription.service';
import { NgxSpinnerService } from 'ngx-spinner';
const DOMPurify = require('dompurify');
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
export interface addSkill {
  name: string;
}
interface Skill {
  id: number;
  name_FR: string;
}
@Component({
  selector: 'app-edit-offre',
  templateUrl: './edit-offre.component.html',
  styleUrls: ['./edit-offre.component.css']
})

export class EditOffreComponent {
 @ViewChild('publier', { static: true }) publierModal!: TemplateRef<any>;
 updateform!: FormGroup;
 safeDescription!: SafeHtml;

  totalItems!: number;

 
  skillsList: Skill[] = [];
  skills: any = [];
  types: any = [];
  addTestChecked: boolean = false;
  addScaleAndTest: boolean = false;
  selectedTest: string = '';
jobofferDetails: any;
  addTestWegestU: boolean = false;
  addTest: boolean = false;
  addScale: boolean = false;
  addComp: boolean = true;
 selectedSkillIds: any[] = [];
  modalRef?: BsModalRef;
  jobId: any;
  mobilities: any[] = [];
  updateSkills: any[] = [];
 id = this.activatedRoute.snapshot.params['id'];
  private unsubscribeAll: Subject<void> = new Subject();
 loadSpinnerTable: boolean = false;
  paysList: any[] = Country.getAllCountries().map((country) => ({
    ...country,
    name: this.translateCountryName(country.name),
  }));
  stateList: any = [];
  states: any = [];
  countries: any = [];
  announcer = inject(LiveAnnouncer);
  formData = new FormData();
  addOnBlur = true;
  showPlaceholder: boolean = true;
  readonly separatorKeysCodes = [ENTER, COMMA] as const;
  contrat = [
    { id: '1', name: 'Alternance' },
    { id: '2', name: 'Autres type de contrat' },
    { id: '3', name: 'CDD' },
    { id: '4', name: 'CDI' },
    { id: '5', name: 'Freelance' },
    { id: '6', name: 'Portage salarial' },
    { id: '7', name: 'Stage' },
  ];
  poste = [
    { id: 1, name: 'A distance' },
    { id: 2, name: 'Hybride' },
    { id: 3, name: 'Sur site' },
  ];
  disponibilite = [
    { id: 1, name: 'Immédiate' },
    { id: 3, name: '2 mois' },
    { id: 4, name: '3 mois' },
    { id: 5, name: '4 mois' },
    { id: 6, name: '5 mois' },
  ];

  constructor(
    private activatedRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private toastr: ToastrService,
    private jobofferservice: EsnJobOfferService,
    private router: Router,
    private salarieservice: SalarieService,
    private modalBsService: BsModalService,
    private localStorageService: LocalStorageService,
    private subscriptionService: SubscriptionService,
    private spinner: NgxSpinnerService,
    private toastrService: ToastrService,
    private sanitizer: DomSanitizer,
  ) {}
  toolbarOptions = [
    ['bold', 'italic', 'underline'], // toggled buttons
    [{ header: 1 }, { header: 2 }], // custom button values
    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ indent: '-1' }, { indent: '+1' }],
    [{ color: [] }, { background: [] }], // outdent/indent
    ['clean'], // remove formatting button
  ];
  ngOnInit() {
    // @ts-ignore
    this.getListSkills();
 this.getjobofferById();
    this.countries = Country.getAllCountries();
  this.updateform = this.formBuilder.group({
      id: [''],
      name: ['', Validators.required],
      city: [[]],
      country: [[], Validators.required],
      post_type: [''],
      contract_type: [''],
      availability: [''],
      skills: [[], Validators.required],
      years_of_experience: ['', Validators.required],
      tjm: [''],
      salary: [''],
      description: ['', Validators.required],
      passeport_talent: [''],
      profile_abroad: [''],
      otherSkills: [[]],
    });
  }
  getListSkills() {
    this.salarieservice.getSkillsJobs().subscribe({
      next: (res: any) => {
        this.skillsList = res.data;
         const hasRefreshed = sessionStorage.getItem('hasRefreshed');
       if (!hasRefreshed) {
      sessionStorage.setItem('hasRefreshed', 'true'); 
      window.location.reload(); 
   
    } else {
      this.showPlaceholder = true;
    }
      },
      error: () => {
        this.toastr.error(serverError);
      },
    });
  }
    getjobofferById() {
    this.spinner.show();
    this.jobofferservice.getjobofferById(this.id).subscribe({
      next: (res: any) => {
        this.spinner.hide();
        this.jobofferDetails = res.data;
          const skillsName = this.jobofferDetails.skills.split(',').map((s:any) => s.trim());
         this.salarieservice.getSkillsJobs().subscribe({
      next: (res: any) => {
        this.skillsList = res.data;
         const selectedSkills = this.skillsList.filter(skill =>
          skillsName.includes(skill.name_FR)
        );
         this.selectedSkillIds = selectedSkills.map(skill => skill.id);
         this.updateform.get('skills')?.setValue(this.selectedSkillIds);
      },
      error: () => {
        this.toastr.error(serverError);
      },
    });
       
        
        this.updateform.patchValue({
        name:   this.jobofferDetails.name,
        city:   this.jobofferDetails.city,
        country:  this.jobofferDetails.country,
        // skills:  this.selectedSkillIds,
        description:  this.jobofferDetails.description,
        salary:  this.jobofferDetails.salary,
        tjm:  this.jobofferDetails.tjm,
        years_of_experience:  this.jobofferDetails.years_of_experience,
        passeport_talent:  this.jobofferDetails.passeport_talent,
        profile_abroad:  this.jobofferDetails.profile_abroad,
        otherSkills:  this.jobofferDetails.otherSkills,
    });
    const postTypeId = Number(this.jobofferDetails.post_type);
    const selectedPoste = this.poste.find(p => p.id === postTypeId);
   if (selectedPoste) {
      this.updateform.get('post_type')?.setValue(selectedPoste.id);
    } else {
      this.updateform.get('post_type')?.setValue(null);
    }
   const availabilityId = Number(this.jobofferDetails.availability);

  const availabiliteValue = this.disponibilite.find(item => item.id === availabilityId);
     if(availabiliteValue) {
      this.updateform.get('availability')?.setValue(availabiliteValue.id);
     }else {
      this.updateform.get('availability')?.setValue(null);
     }
    this.updateform.get('contract_type')?.setValue( this.jobofferDetails.contract_type);
    this.updateform.get('contract_type')?.updateValueAndValidity();
    this.onCountryChange('add');
        this.updateDescription(this.jobofferDetails.description);
      },
      error: () => {},
    });
  }
  updateDescription(description: string) {
    const sanitizedHtml = DOMPurify.sanitize(description);
    this.safeDescription = this.sanitizer.bypassSecurityTrustHtml(sanitizedHtml);
  }
updatejoboffer() {

  this.updateform.markAllAsTouched();
  this.updateform.markAsDirty();
    const skills = this.updateform.get('skills')?.value || [];
    this.skills = skills.map((skill: any) => skill);

    let otherSkills = this.updateform.get('otherSkills')?.value;
    if (typeof otherSkills === 'string' && otherSkills) {
      otherSkills = otherSkills.split(',').map(skill => skill.trim());
    }

    if (this.updateform.value.availability === null) {
      this.updateform.patchValue({ availability: '' });
    }

    if (this.updateform.value.post_type === null) {
      delete this.updateform.value.post_type;
    }

    this.updateform.patchValue({
      years_of_experience: this.updateform.value?.years_of_experience? String(this.updateform.value?.years_of_experience) : null,
      salary: this.updateform.value?.salary? String(this.updateform.value?.salary) : null,
      tjm: this.updateform.value?.tjm? String(this.updateform.value.tjm) : null,
      skills: this.skills,
      otherSkills: otherSkills || [],
    });

    this.jobofferservice.updateJobOffer(this.id, this.updateform.value)
      .subscribe({
        next: (res: any) => {
          this.toastrService.success('Offre d\'emploi modifiée avec succès');
         this.router.navigate([`/offres-emploi/details-offer/${this.id}`]);
        },
        error: (error) => {
        },
      });
  }

   
  selectCountry() {
    this.states = State.getStatesOfCountry(this.updateform.value.country);
  }
  showPasseportTalent: boolean = false;

  onCountryChangeSearch(mode: string): void {

    this.updateform.get('city')?.enable();
    this.countries = this.updateform.get('country')?.value;
    this.countries = this.countries.map(
      (item:any) => this.paysList.filter((it) => it.name === item)[0]
    );
    this.stateList.length = 0;
    this.mobilities = this.updateform.get('city')?.value;

    this.countries.forEach((item:any) => {
      var after:any[]=State.getStatesOfCountry(item?.isoCode)
      if(after.length==0)
      after.push({name:"Tout le pays"})
      this.stateList.push(after);
    });
    this.stateList = this.stateList.flat();
    for (const iterator of this.stateList) {
      iterator.name = iterator.name.replace(' Governorate', '');
    }
    this.stateList = this.stateList.map((item: any) => item.name);
    if (this.mobilities != null && this.mobilities.length > 0) {
      let differentItemsArray1: any[] = [];
      differentItemsArray1 = this.mobilities.filter(
        (item) => !this.stateList.includes(item)
      );
      var differentItemsArray2:any[]=[];
      differentItemsArray2= this.mobilities.filter((item) => !differentItemsArray1.includes(item));
      this.updateform.get('city')?.setValue(differentItemsArray2);
    }

    if (this.stateList.length == 0) {
      this.stateList = [];
      mode == 'add';
      if(this.countries.length==0) {
        this.updateform.get('city')?.disable();
        this.updateform.get('city')?.setValue(null);
        }

    }
    this.showPasseportTalent = this.countries.some(
      (country: any) => country.name ==='France'
    );
  }

  onMobilityChange(mode: string) {
    this.mobilities = this.updateform.get('city')?.value;
    let paysLists: any[] = [];
    this.countries = this.updateform.get('country')?.value;
    this.countries = this.countries.filter(async (item: any) => {
      paysLists.push(this.paysList.filter((it) => it.name === item)[0]);
    });
    let stateListAfter: any[] = [];
    paysLists.forEach((item) => {
      State.getStatesOfCountry(item.isoCode).forEach(item=> {
        stateListAfter.push(item.name);    ////  }
      })
    });
    this.stateList = [...new Set(this.mobilities.concat(stateListAfter))];
    this.mobilities = this.updateform.get('city')?.value;

    if (this.countries.length != 0) {
      if (this.mobilities.length === 0 && this.stateList.length === 0) {
        this.onCountryChange('add');
      }
    }
  }
  onCountryChange(mode: string): void {
    this.updateform.get('city')?.enable();
    this.countries = this.updateform.get('country')?.value;
    this.countries = this.countries.map(
      (item: any) => this.paysList.filter((it) => it.name === item)[0]
    );
    this.stateList.length = 0;
    // if (event.length) {
    this.countries.forEach((item: any) => {
      this.stateList.push(State.getStatesOfCountry(item.isoCode));
    });
    this.stateList = this.stateList.flat();
    for (const iterator of this.stateList) {
      iterator.name = iterator.name.replace(' Governorate', '');
    }
    this.stateList = this.stateList.map((item: any) => item.name);
   
    this.mobilities = this.updateform.get('city')?.value;
    if (this.mobilities != null && this.mobilities.length > 0) {
      let differentItemsArray1: any[] = [];
      differentItemsArray1 = this.mobilities.filter(
        (item) => !this.stateList.includes(item)
      );
      const differentItemsArray2 = this.mobilities.filter(
        (item) => !differentItemsArray1.includes(item)
      );
      this.updateform.get('city')?.setValue(differentItemsArray2);
    }
    // }
    if (this.stateList.length == 0) {
      this.stateList = [];
      mode == 'add';
      this.updateform.get('city')?.setValue(null);
    }
    this.showPasseportTalent = this.countries.some(
      (country: any) => country.name ==='France'
    );
  }
  findDuplicates(array1: any, array2: any) {
    let occurrences: any[] = [];
    let duplicates: any = [];
    for (let element of array1) {
      occurrences[element] = (occurrences[element] || 0) + 1;
    }
    for (let element of array2) {
      if (occurrences[element] && !duplicates.includes(element)) {
        duplicates.push(element);
      }
    }

    return duplicates;
  }
  translateCountryName(name: string): string {

    return translations[name] || name;
  }
  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalBsService.show(template, { backdrop: 'static' });
    this.modalRef.onHidden?.subscribe(() => {
      this.onConfirm(this.jobId);
    });
  }
  addSkills: addSkill[] = [];

  edit(skill: addSkill, event: MatChipEditedEvent) {
    const value = event.value.trim();

    if (!value) {
      this.remove(skill);
      return;
    }

    const index = this.addSkills.indexOf(skill);
    if (index >= 0) {
      this.addSkills[index].name = value;
    }
  }
  isFormatCompetenceAdmin: boolean = false;

  // add(event: MatChipInputEvent): void {
  //   const value: any = (event.value || '').trim();
  //   if (this.isFormatCompetence(value)) {
  //     if (!this.addSkills?.some((item) => item.name === value)) {
  //       this.updateSkills.push(value);
  //       this.addSkills?.push({ name: value });
  //       this.isFormatCompetenceAdmin = false;
  //     }
  //   } else {
  //     this.isFormatCompetenceAdmin = true;
  //   }
  //   event.chipInput!.clear();
  // }
  add(event: MatChipInputEvent): void {
    const value: any = (event.value || '').trim();

    if (value && this.isFormatCompetence(value)) {
      if (!this.addSkills.some(skill => skill.name === value)) {
        this.addSkills.push({ name: value });
          this.updateSkillsText();
      }
    }
      event.chipInput!.clear();
  }

  isFormatCompetence(competence: string): boolean {
    // Vérifie que la compétence commence par une lettre ou un chiffre, ne contient que des lettres, des chiffres, des espaces, des points, des hashtags ou des plus, et n'est pas composée uniquement de chiffres
    const pattern = /^(?!^\d+$)[a-zA-Z0-9][a-zA-Z0-9#.\s]*\+*$/;
    return pattern.test(competence);
  }
  // remove(skill: addSkill): void {
  //   const index = this.addSkills.indexOf(skill);

  //   if (index >= 0) {
  //     this.addSkills.splice(index, 1);

  //     this.updateSkillsText();

  //     this.formData.delete('otherSkills[]');

  //     this.addSkills.forEach((skill) => {
  //       this.formData.append('otherSkills[]', skill.name);
  //     });

  //     if (this.addSkills.length === 0) {
  //       this.formData.append('otherSkills[]', '');
  //     }

  //     this.announcer.announce(`Removed ${skill.name}`);
  //   }
  // }
  remove(skill: addSkill): void {
    const index = this.addSkills.indexOf(skill);

    if (index >= 0) {
      this.addSkills.splice(index, 1);
        this.updateSkillsText();
    }
  }

  // updateSkillsText(): void {
  //   const skillsText = this.addSkills.map((skill) => skill.name);
  //   this.updateform.get('otherSkills')?.setValue(skillsText);

  //   this.formData.delete('otherSkills[]');
  //   skillsText.forEach((text) => {
  //     this.formData.append('otherSkills[]', text);
  //   });

  //   if (skillsText.length === 0) {
  //     this.formData.append('otherSkills[]', '');
  //   }
  // }
  updateSkillsText(): void {
    const skillsText = this.addSkills.map(skill => skill.name);
  
    this.updateform.patchValue({ otherSkills: skillsText });
  }

  onConfirm(jobId: any) {
    if (this.addTestChecked && this.addTestWegestU) {
      this.router.navigate(['/offres-emploi/add-test-wegestu'],
        {
          queryParams: { jobId: jobId },
          state: {  testType: 'NO_TEST' },
        });
    } else if (this.addTestChecked && this.addTest) {      
      this.router.navigate(['/offres-emploi/add-test'],
        {
          queryParams: { jobId: jobId },
          state: {  testType: 'NO_TEST' },
        });
    } else if (this.addScaleAndTest) {
      this.router.navigate([
        '/offres-emploi/add-bareme',
        { jobId: jobId , state:0},
      ]);
    }
    else if (this.addScale) {
      this.router.navigate([
        '/offres-emploi/add-bareme',
        { jobId: jobId},
      ]);
    }
    this.closeModal()
  }
  closeModal() {
    this.modalRef?.hide();
  }
  closeModalAndRedirect() {
    // Réinitialiser les états des cases à cocher
    this.addScale = false;
    this.addTestChecked = false;
    this.addTest = false;
    this.addTestWegestU = false;

    // Fermer la modale et rediriger
    this.modalRef?.hide();
    this.router.navigate(['/offres-emploi/liste-offres-emploi']);
}
  

  /* unsubscribe from api */
  ngOnDestroy() {
    this.unsubscribeAll.next();
    this.unsubscribeAll.complete();
  }
  onAddScaleChange() {
    if (this.addScale) {
        this.addTestChecked = false;
    }
}


onTestChange(): void {
  if (this.selectedTest === 'wegestu') {
    this.addTestWegestU = true;
    this.addTest = false;  // Ensure mutual exclusivity
  } else if (this.selectedTest === 'test') {
    this.addTestWegestU = false;
    this.addTest = true;  // Ensure mutual exclusivity
  }
}
onAddTestChange() {
    if (this.addTestChecked) {
        this.addScale = false;
        this.addScaleAndTest =false
    }
    else if(this.addScale){
      this.addTestChecked = false;
      this.addScaleAndTest =false
    }
    else if(this.addScaleAndTest){
      this.addScale = false;
      this.addTestChecked =false
    }
}
subscriptionCanAccess(featureName: string): boolean {
  return this.subscriptionService.subscriptionCanAccess(featureName);
}
onContentChange(event: any): void {
  if (event.html) {
    const sanitizedContent = DOMPurify.sanitize(event.html);
    if (sanitizedContent !== this.updateform.get('description')?.value) {
      this.updateform.patchValue(
        { description: sanitizedContent },
        { emitEvent: false } 
      );
    }
  }

}
}
